// extracted by mini-css-extract-plugin
export default {"yellowTag":"RestaurantSchedule-module__yellowTag___1Ov7t","greyTag":"RestaurantSchedule-module__greyTag___21WM1"};